import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'nonMediaSubType';

export class NonMediaSubType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
